module.exports = require("browser-image-size");